import type { PropsWithChildren } from 'react';

import { Link, Para, Stack } from '@drycut/ui-components';
import { twMerge } from 'tailwind-merge';

import BubbleBlackImage from '../../assets/bubble_black.svg';
import { useBookingContext } from './BookingStepper/BookingProvider';

type Props = PropsWithChildren<{
  className?: string;
  storeSlug: null | string | undefined;
}>;

export function PassBubble({ storeSlug, className }: Props): React.ReactElement {
  const { manual } = useBookingContext();
  const bgStyle = {
    background: `url("${BubbleBlackImage}") no-repeat`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
  };

  const href = manual ? `/${storeSlug}/passes` : '/passes';

  return (
    <Link href={href} className="no-underline">
      <Stack
        style={bgStyle}
        className={twMerge(
          'absolute flex flex-col justify-center h-32 p-4 pb-8 w-28 -top-16 -right-28',
          'text-white hover:scale-110 transition-transform duration-300 ease-in-out',
          className,
        )}
      >
        <Para>Save with</Para>
        <Para weight="bold">DRYPASS</Para>
      </Stack>
    </Link>
  );
}
